import { FormFields } from ".";

export const KYC_DETAILS: FormFields = {
  fields: [
    {
      name: "panNumber",
      label: "Pan No.",
      type: "text",
      validationRules: {
        required: true,
        pattern: {
          value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          message: "Please enter a valid PAN number",
        },
      },
    },
    {
      name: "aadharNumber",
      label: "Aadhar - last 4 digit",
      type: "text",
      validationRules: {
        required: false,
        pattern: {
          value: /^\d{4}$/,
          message: "Please enter last 4 digits of Aadhar number",
        },
      },
    },
    {
      name: "voterIdNumber",
      label: "Voter Id",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "passportNumber",
      label: "Passport Number",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "drivingLicenseNumber",
      label: "Driving License",
      type: "text",
      validationRules: {
        required: false,
      },
    },
  ],
};
